import React from 'react';
import { AppContext } from '../../App';
import Betslip from '../../data/betslip-alt/BetslipAlt';
import { BetslipContext } from '../../data/betslip/BetslipConf';

export default function BetslipAlt(props) {
    const appContext = React.useContext(AppContext);
	const betslipContext = React.useContext(BetslipContext);
    return <> {
    	betslipContext.betslipData &&
        <Betslip toggleBetslip={() => appContext.toggleBetslip()}
                 toggleFastbetPopup={() => appContext.toggleFastbetPopup()}
                 toggleMyBets={() => appContext.toggleMyBets()} />
    }
    </>
}
